import { Link } from 'react-router-dom'

function Header() {
	return (
		<>
			<header className='text-gray-700 body-font border-b border-gray-200'>
				<div className='container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center'>
					<Link
						to='/'
						className='flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0'>
						<svg
							fill='none'
							stroke='currentColor'
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth='2'
							className='w-10 h-10 text-white p-2 bg-blue-500 rounded-full'
							viewBox='0 0 24 24'>
							<path d='M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'></path>
						</svg>
						<span className='ml-3 text-xl'>CRYPTO</span>
					</Link>
					<nav className='md:ml-auto flex flex-wrap items-center text-base justify-center'>
						<Link to='/signin' className='mr-5 hover:text-gray-900'>
							Sign In
						</Link>
					</nav>
					<Link to='/signup' className='mr-5 hover:text-gray-900'>
						<button className='inline-flex items-center bg-blue-500 text-white border-0 py-1 px-3 focus:outline-none hover:bg-blue-600 rounded text-base mt-4 md:mt-0'>
							Sign Up
							<svg
								fill='none'
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								className='w-4 h-4 ml-1'
								viewBox='0 0 24 24'>
								<path d='M5 12h14M12 5l7 7-7 7'></path>
							</svg>
						</button>
					</Link>
				</div>
			</header>
		</>
	)
}
export default Header
